import React from 'react';
import {Translate} from "../../../components/util/translation.util";
import {Form, Input} from "antd";
import {TranslationDomainEnum} from "../../../types/enums";

export const PasswordType: React.FC<{
    name: string,
    label: string,
    translationDomain?: TranslationDomainEnum,
    rules?: any,
    onChange?: () => void,
    errors: { [key: string]: string[] }
    validateTrigger?: string,
}> = ({name, label, translationDomain, rules, onChange, errors, validateTrigger= 'onBlur'}) => (
    <Form.Item
        labelAlign={`left`}
        name={ name.split('.') }
        label={<Translate message={label} domain={translationDomain} />}
        rules={rules}
        validateTrigger={validateTrigger}
    >
        <Input.Password onChange={onChange} />
    </Form.Item>
)
